import { message} from "antd";

import React, { Component } from 'react';
import 'antd/dist/antd.css';

import { Redirect, Route } from "react-router-dom";
class NotifyMessage extends Component {
    constructor(props) {
        super();

    }

    showSuccessMessage(texts){
        message.success({
            content: texts,
            className: 'custom-class',
            style: {
              marginTop: '5vh',
            },
            duration: .5
          });
        }
    componentDidMount() {
        console.log('in componentdidmount')
    }

    render() {
        return (
            //fake render
            <div></div>
        )
    }
}
export default NotifyMessage
